import { SessionQuery } from 'front-end/src/public-api/hooks/usePublicApiSession.codegen'
import { omit } from 'lodash'
import { OrganisationQuery } from 'front-end/src/public-api/hooks/useOrganisation.codegen'

export const createSentrySessionOverview = (
  session: SessionQuery['session'],
  organisation: OrganisationQuery['organisation']
) => {
  if (!session?.user) {
    return null
  }
  const { user } = session
  const {
    id,
    userIdentity,
    is_active,
    is_archived,
    organisation_id,
    organisation_role,
    preferences,
    timezone,
    verified
  } = user
  return {
    admin_org_link: `https://app.looop.co/admin/organisation/${organisation_id}/users/${user.id}`,
    user_id: id,
    userIdentity,
    organisationFeatures: organisation?.features,
    is_active,
    is_archived,
    organisation_id,
    organisation_role,
    preferences,
    session: omit(session, 'user'),
    timezone,
    verified
  }
}
